export default __webpack_public_path__ + "assets/models/03a35c26b55f88d965dda0e349b161ec.glb";